import React from 'react';
import { DateField, FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import EmployeeContractEndDateLayout from 'domain/people/contracts/shared/layout/EmployeeContractEndDateLayout';
import { UiThemeOverrider } from 'framework/uiTheme';
import { SimpleFieldLayout, InputTooltip } from 'framework/ui/layout';
import { useUiTheme } from 'framework/uiTheme';
import EmployeeContractWillExpireSoonBadge from 'domain/people/contracts/shared/RelatedContractsList/badge/EmployeeContractWillExpireSoonBadge';
import useContractsService from 'domain/people/contracts/shared/contractsService';
import ContractInfinitySymbol from './ContractInfinitySymbol';

const ContractEndDateField = (props: FieldProps<string> | undefined) => {
  const { BaseFieldLayout } = useUiTheme();
  const { getValue, getLabel } = useFieldHelper(props);
  const { getValue: getIsIndefiniteValue } = useFieldHelper({ source: 'isIndefinite' });
  const { isContractWillExpireSoon } = useContractsService();

  const value = getValue();
  const isIndefinite = getIsIndefiniteValue();
  const notification = isContractWillExpireSoon(value) ? <EmployeeContractWillExpireSoonBadge /> : null;
  const badgeNotification = isIndefinite ? (
    <InputTooltip source="" message="Contract for an indefinite period" />
  ) : null;

  return (
    <BaseFieldLayout
      label={
        <>
          {getLabel()}
          {badgeNotification}
        </>
      }
      value={
        <UiThemeOverrider
          overriddenLayouts={{
            BaseFieldLayout: SimpleFieldLayout,
          }}
        >
          <EmployeeContractEndDateLayout
            dateField={isIndefinite ? <TextField value={<ContractInfinitySymbol />} /> : <DateField value={value} />}
            notification={notification}
          />
        </UiThemeOverrider>
      }
    />
  );
};

export default ContractEndDateField;
